var map = {
	"./Development.js": [
		6776,
		6776
	],
	"./Game_Mechanics.js": [
		3973,
		3973
	],
	"./Patchnotes.js": [
		8652,
		8652
	],
	"./Premade_Land_Life.js": [
		6757,
		6757
	],
	"./Premade_Microbes.js": [
		3093,
		3093
	],
	"./Premade_Sea_Life.js": [
		7776,
		7776
	],
	"./Stages.js": [
		6246,
		6246
	],
	"./World.js": [
		388,
		388
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5704;
module.exports = webpackAsyncContext;